import { usersTypes } from '../actions/_users_actions';

const usersDefaultState = [];

export default (state = usersDefaultState, action) => {
  switch (action.type) {
    case usersTypes.FETCH_USERS_DATA:
      return [...action.users];
    default:
      return state;
  }
};
